const formatPrice = (price: number, freePriceText: string, withPence: boolean = false) => {
    if (price === 0.0) return freePriceText;

    const absolutePrice = Math.abs(price);
    const formattedPrice = absolutePrice.toLocaleString("en-GB", {
        minimumFractionDigits: withPence ? 2 : 0,
        maximumFractionDigits: withPence ? 2 : 0,
    });

    return `${price < 0 ? "-" : ""}£${formattedPrice}`;
};

export default formatPrice;
